module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAkUlEQVQ4y9WQIQ4DIRQFMYhFYAo3qEKgMFygd9hkBTfgHOvB1uJIuBTVONxrg2yazWYVnWTcz+TlEzIFL3LDFScKfMC3y7LAez/UWuPXzWGglIIYI6SUyDkjhABr7flA7x2MMazrilorWmvgnJ8PpJTGAiEE9n2HMQZKqfMBSimcc9i2bSw5/MH9+cAVJwr8N2/b+AxR5JyaCQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/LY.png
// module id = 1199
// module chunks = 0